import { LottieAnimation } from '@billy/design-system'
import cc from 'classcat'
import React, { useEffect, useRef } from 'react'

import { reactClass } from '../../utils'

export type SuccessErrorAnimatedIconProps = {
  className?: string
  success?: boolean
}

export const SuccessErrorAnimatedIcon = ({ className, success }: SuccessErrorAnimatedIconProps) => {
  const animationRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // No clear guidelines for using Lottie with TypeScript
    const { anim } = animationRef.current as any

    const handleStart = () => {
      anim.loop = false
    }

    handleStart()
  }, [success])

  return (
    <div className={cc([className, reactClass('success-error-animated-icon')])}>
      <LottieAnimation name={success ? 'successIcon' : 'errorIcon'} ref={animationRef} />
    </div>
  )
}
